<template>
  <l-marker
    v-if="query"
    :lat-lng="query.latlng"
    :visible="query.visible"
    @add="onAdd"
    @popupopen="_setQuery"
    @popupclose="_unsetQuery"
  >
    <l-popup ref="popup">
      <q-spinner v-if="!query.component" />
      <component v-bind:is="query.component" :results='query.results' :latlng='query.latlng' @remove-query="_removeQuery">
        test
      </component>
      <div class="tools" v-if="query.component">
        <q-btn flat dense
          size="sm"
          style="margin-top: 1em"
          icon="delete"
          @click="_removeQuery"
        />
      </div>
    </l-popup>
  </l-marker>
</template>

<script>
import QueryOnClick from '@giscube/geoportal'

import PopupPlus from 'components/PopupPlus.vue'

export default {
  extends: QueryOnClick,
  name: 'query-on-click',
  data () {
    return {
      map: null,
      mapClicks: 0,
      mapClickDelay: 300,
      mapClickTimer: null,
      query: null
    }
  },
  methods: {
    async queryAfterOverlays (event, marker) {
      marker.component = PopupPlus
      return null
    }
  }
}
</script>
